import { Modal, Table, Tree } from "antd"
import styles from './index.less'
import { useEffect, useState } from "react"
import { CLINIC_NAME } from "@/utils/consts"

const { TreeNode } = Tree

const ChangeRoleModal = ({ clinics = [], current, currentCode = '', currentClinicProp, onOk, ...modalOtps }) => {
  const tableColumns = [{
    dataIndex: 'displayName',
    title: '角色名称',
    width: 180,
  }, {
    dataIndex: 'name',
    title: '角色身份',
    width: 180,
  }, {
    dataIndex: 'dataPermissions',
    title: '数据权限',
    width: 100,
    render(text) {
      if (text && text.length)
        return text[0].name

      return '-'
    }
  }]

  const [roles, setRoles] = useState([])
  const [currentRole, setCurrentRole] = useState(0)
  const [currentRoleCode, setCurrentRoleCode] = useState('')
  const [currentDataPermission, setCurrentDataPermission] = useState('')
  const [currentClinic, setCurrentClinic] = useState('')
  const [currentClinicName, setCurrentClinicName] = useState('')
  const [currentClinicLogo, setCurrentClinicLogo] = useState('')
  const [selectedLogo, setSelectedLogo] = useState('')
  const [selectedKey, setSelectedKey] = useState([])
  const [selectedName, setSelectedName] = useState(window.localStorage.getItem(CLINIC_NAME))
  const [currentApplicationId, setCurrentApplicationId] = useState('')
  const [currentUrlPermissions, setCurrentUrlPermissions] = useState([])
  const [currentRecord, setCurrentRecord] = useState({})

  useEffect(() => {
    if (current) {
      setCurrentRole(Number(current))
    }
    if (currentCode) {
      setCurrentRoleCode(currentCode)
    }
    if (currentClinicProp) {
      setSelectedKey([currentClinicProp])
      setCurrentClinic(currentClinicProp)
      clinics.forEach((item) => {
        if (`${item.id}` === currentClinicProp) {
          setRoles(item.userClinicRoles || [])
        }
      })
    } else if (currentClinicProp === '') {
      setSelectedKey(['0'])
      setCurrentClinic('')
      clinics.forEach((item) => {
        if (`${item.id}` === '0') {
          setRoles(item.userClinicRoles || [])
        }
      })
    }
  }, [])

  const handleOk = () => {
    if (!currentRole) return
    onOk(currentRole, currentRoleCode, currentDataPermission, currentClinic, currentApplicationId, currentUrlPermissions, currentClinicName, currentClinicLogo, currentRecord)
  }

  const onTreeSelect = (selectedKeys, e) => {

    if (selectedKeys[0] !== selectedKey[0] && e.selected) {
      setSelectedKey(selectedKeys)
      clinics.forEach((item) => {
        if (`${item.id}` === selectedKeys[0]) {
          setRoles(item.userClinicRoles || [])
          setSelectedName(item.shortName || item.name)
          setSelectedLogo(item.logo)
        }
      })
    }
  }

  return (
    <Modal {...modalOtps} onOk={() => handleOk()} className={styles.changeRole}>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1, overflow: 'hidden' }}>
          <Tree defaultExpandAll onSelect={onTreeSelect} selectedKeys={selectedKey} >
            <TreeNode key={'source'} title='所属门店' selectable={false}>
              {clinics.map((item, index) => {
                return (<TreeNode key={item.id} title={item.shortName}>

                </TreeNode>)
              })}
            </TreeNode>
          </Tree>
        </div>
        <div style={{ flex: 2, marginLeft: 10 }}>
          <Table
            size="middle"
            pagination={false}
            columns={tableColumns}
            rowKey="roleId"
            dataSource={roles}
            onRow={(record) => {
              return {
                onClick() {
                  if (!record.enable) {
                    return
                  }
                  setCurrentRole(record.roleId)
                  setCurrentRoleCode(record.code)
                  const dataPermission = (record.dataPermissions && record.dataPermissions.length) ? record.dataPermissions[0].value : 'PERSONAL'
                  setCurrentDataPermission(dataPermission)
                  setCurrentClinic(selectedKey[0] === '0' ? '' : selectedKey[0])
                  setCurrentApplicationId(record.applicationId)
                  setCurrentUrlPermissions(record.permissions)
                  setCurrentClinicName(selectedName)
                  setCurrentClinicLogo(selectedLogo)
                  setCurrentRecord(record)
                }
              }
            }}
            rowClassName={(record) => { return `${record.roleId}${record.clinicId || ''}` === `${currentRole}${currentClinic}` ? (record.enable ? 'current-row' : 'current-row disabled-row') : (record.enable ? 'row' : 'row disabled-row') }}
          />
        </div>
      </div>

    </Modal>
  )
}

export default ChangeRoleModal